import { useSnackbar } from 'notistack';
import useTimeoutedEffect from '../../hooks/useTimeoutEffect';
import { apiGetMe, apiGetUserRole } from '../../services/user.api';
import { useAuthStore } from '../../store/useAuthStore';
import { useMessagesStore } from "../../store/useMessagesStore";

export const AppEffectsHandler = () => {
  const { enqueueSnackbar } = useSnackbar();
  const lastMessage = useMessagesStore((state) => state.lastMessage);
  const authStore = useAuthStore();

  useTimeoutedEffect(() => {
    if (!lastMessage) return;
    const { message, variant } = lastMessage;
    enqueueSnackbar(message, { variant })
  }, [lastMessage]);

  useTimeoutedEffect(async () => {
    if (!authStore.user) return;
    const role = await apiGetUserRole(authStore.user.userRoleId);
    if (role) {
      authStore.setUserRole(role);
    }
  }, [authStore.user])

  useTimeoutedEffect(async () => {
    if (!authStore.user) return;
    const me = await apiGetMe();
    if (me) {
      authStore.setMe(me);
    }
  }, [authStore.user])

  return null
};

export default AppEffectsHandler;
